module.exports = __webpack_public_path__ + "static/field_trip_img4@2x-69072b42039d25b6e9dd14632e8efd7c.jpg";